import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMediaQuery } from '@common/hooks';
import { gtmEventHandler } from '@common/utils/gtm';

import SharedIcon from '@alumni_v2/images/svg/shared.svg';
import ShareModal from '@alumni_v2/ui/ShareModal/';
import {
  requestParamsSelector,
} from '@alumni_v2/selectors/reviews';
import { toggleShareState } from '../../stores/reviews/actions';

import styles from './ShareProfile.module.scss';

const ShareProfile = () => {
  const { tablet } = useMediaQuery();

  const dispatch = useDispatch();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);

  const isShareable = useSelector((state) => state.reviews.isShareable);
  const requestParams = useSelector(requestParamsSelector) || {};
  const isObjectNotEmpty = (obj) => obj && Object.keys(obj).length > 0;
  const isFilterApplied = (requestParams?.quickFilters?.length > 0)
                          || isObjectNotEmpty(requestParams?.advancedFilters)
                          || false;

  useEffect(() => {
    if (window.__INITIAL_STATE__
          && window.__INITIAL_STATE__.currentUser !== '') {
      setIsLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    if (window.location.href) {
      const urlParams = new URLSearchParams(window.location.search);
      const shared = urlParams.get('shared');
      if (shared) {
        dispatch(toggleShareState());
      }
    }
  }, [dispatch]);

  const handleShareReviewUrl = () => {
    const currentUrl = window.location.href;
    if (!currentUrl.includes('shared=true')) {
      const newUrl = `${window.location.href}&shared=true`;
      window.history.pushState({ path: newUrl }, '', newUrl);
    }
    gtmEventHandler(
      'cta',
      'AlumniPage_Mutipleprofileshare',
      'click',
      'alumni_directory',
    );
    setIsShareOpen(true);
  };

  const shareData = {
    text: `Scaler Review Page`,
    url: `${window.location.href}`,
  };

  const toggleShareModal = useCallback(() => {
    setIsShareOpen(!isShareOpen);
  }, [isShareOpen]);

  return (
    <>
      {tablet ? (
        (
          <button
            type="button"
            className={styles.shareProfileContainer}
            onClick={handleShareReviewUrl}
          >
            <div className={styles.icon}>
              <img src={SharedIcon} alt="sharedIcon" />
            </div>
            <div className={styles.shareText}>Share Profile</div>
          </button>
        )
      ) : (
        <>
          <div className={styles.shareContainer}>
            {isShareable && isFilterApplied && isLoggedIn
        && (
          <button
            type="button"
            className={styles.shareProfileWrapper}
            onClick={handleShareReviewUrl}
          >
            <div className={styles.icon}>
              <img src={SharedIcon} alt="sharedIcon" />
            </div>
            <div className={styles.shareProfile}>Share Profiles</div>
          </button>
        )}
          </div>
        </>
      )}

      <ShareModal
        isOpen={isShareOpen}
        onModalClose={toggleShareModal}
        shareLink={shareData.url}
        shareMessage={shareData.text}
      />
    </>
  );
};

export default ShareProfile;
